/**
 * 统一从节点 data 中提取图片/视频 URL
 * 覆盖所有节点类型：resource(url/thumbnail), generate(lastResultUrl/result), storyboardShot(generatedImage/generatedVideo)
 */
export const getNodeImageUrl = (nodeData) => {
  return nodeData?.url || nodeData?.thumbnail || nodeData?.lastResultUrl || nodeData?.result
    || nodeData?.generatedImage || nodeData?.generatedVideo;
};
